module.exports = __webpack_public_path__ + "static/media/touch.e72c88ac.mp3";